module.exports = __webpack_public_path__ + "static/img/HOME2 1680x1050.a2a256a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/match/HOME2 1680x1050.jpg
// module id = tgF5
// module chunks = 47